import {ISelectorState} from '../selector.state';
import {NgRedux} from '@angular-redux/store';
import {Action} from 'redux';
import {Injectable} from '@angular/core';

export interface ActionLocal extends Action<string> {
  // type: string;
  payload?: any;
}

@Injectable()
export class ActionsService {
  constructor(private ngRedux: NgRedux<ISelectorState>) {   }

  sendAction(act: ActionLocal) {
    this.ngRedux.dispatch(act);
  }

}

